"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _APButton = _interopRequireDefault(require("../../../common/APButton"));
var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal"));
var _DeclineModal = _interopRequireDefault(require("./DeclineModal"));
var _EnableFuturesModal = _interopRequireDefault(require("./EnableFuturesModal"));
var _positionFormatter = require("../../../../helpers/positionFormatter");
var _config = _interopRequireDefault(require("../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var themeClasses = (0, _cssClassesHelper.getBEMClasses)('trade-settings');
var FuturesTradingSetting = function FuturesTradingSetting(_ref) {
  var openEnableFuturesTradingModal = _ref.openEnableFuturesTradingModal,
    futuresEnabled = _ref.futuresEnabled,
    isSpotAccountFrozen = _ref.isSpotAccountFrozen,
    minDepositValue = _ref.minDepositValue,
    baseAssetSymbol = _ref.baseAssetSymbol,
    isVLCheckPassed = _ref.isVLCheckPassed,
    isSpotAccountBalanceValidationPassed = _ref.isSpotAccountBalanceValidationPassed,
    isAllChecksPassed = _ref.isAllChecksPassed,
    isDoubleWarning = _ref.isDoubleWarning;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: themeClasses('futures-box')
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: themeClasses('box-header')
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('Futures Trading'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "divider"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('futures-box-body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('box-body-main-content-container')
  }, /*#__PURE__*/_react["default"].createElement("p", null, t(_config["default"].FuturesTrading.cardText)), /*#__PURE__*/_react["default"].createElement("p", {
    className: themeClasses('futures-status')
  }, futuresEnabled ? /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    ns: "futures"
  }, "Futures Trading is ", /*#__PURE__*/_react["default"].createElement("strong", null, "enabled")) : /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    ns: "futures"
  }, "Futures Trading is ", /*#__PURE__*/_react["default"].createElement("strong", null, "disabled"))), isAllChecksPassed && !futuresEnabled && /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    customClass: themeClasses('submit-button'),
    onClick: function onClick() {
      return openEnableFuturesTradingModal(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('Enable'))), futuresEnabled && /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    className: "".concat(themeClasses('view-terms-button'), " clear"),
    type: "button",
    onClick: function onClick() {
      return openEnableFuturesTradingModal(true);
    }
  }, t('View Terms & Conditions'))), (isSpotAccountFrozen || !isVLCheckPassed) && !futuresEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(themeClasses('warning-container'), " ").concat(themeClasses("warning-container".concat(isDoubleWarning ? '_double' : '')))
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: themeClasses('warning-text-highlighted')
  }, t('You are not eligible for Futures Trading.')), /*#__PURE__*/_react["default"].createElement("br", null), t('Please contact the support team if you have questions about requisites to enable Futures.')), !isSpotAccountBalanceValidationPassed && !futuresEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(themeClasses('warning-container'), " ").concat(themeClasses("warning-container".concat(isDoubleWarning ? '_double' : '')))
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: themeClasses('warning-text-highlighted')
  }, t('You do not have enough funds in your spot account to enable Futures.')), /*#__PURE__*/_react["default"].createElement("br", null), t('The minimum value in any asset in your spot account converted to {{asset}} must be {{value}}', {
    asset: baseAssetSymbol,
    value: "".concat((0, _positionFormatter.formatValue)(minDepositValue, baseAssetSymbol), " ").concat(baseAssetSymbol)
  }))), /*#__PURE__*/_react["default"].createElement(_EnableFuturesModal["default"], null), /*#__PURE__*/_react["default"].createElement(_ConfirmationModal["default"], null), /*#__PURE__*/_react["default"].createElement(_DeclineModal["default"], null));
};
FuturesTradingSetting.defaultProps = {
  futuresEnabled: false
};
FuturesTradingSetting.propTypes = {
  openEnableFuturesTradingModal: _propTypes["default"].func.isRequired,
  futuresEnabled: _propTypes["default"].bool.isRequired,
  isSpotAccountFrozen: _propTypes["default"].bool.isRequired,
  minDepositValue: _propTypes["default"].number.isRequired,
  baseAssetSymbol: _propTypes["default"].string.isRequired,
  isVLCheckPassed: _propTypes["default"].bool.isRequired,
  isSpotAccountBalanceValidationPassed: _propTypes["default"].bool.isRequired,
  isAllChecksPassed: _propTypes["default"].bool.isRequired,
  isDoubleWarning: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = FuturesTradingSetting;